/**
 * Mapa opcional conselho → ValueSet de CBO (FHIR R5).
 * Se o conselho não estiver no mapa, não montamos URL — evita $expand inválido.
 * Canonical alinhado a: https://fluxmed.cloud/fhir/r5/ValueSet/{id}
 */
export const FHIR_R5_VALUESET_BASE = "https://fluxmed.cloud/fhir/r5/ValueSet";

export const CONSELHOS_SAUDE_VALUESET_ID = "conselhos-saude";

/** ValueSet de CBO por sigla do conselho (vínculo opcional). */
export const CBO_VALUESET_BY_CONSELHO: Record<string, string> = {
  CRM: "cbo-crm",
  COREN: "cbo-coren",
  CRO: "cbo-cro",
  CREFITO: "cbo-crefito",
  CRP: "cbo-crp",
  CRF: "cbo-crf",
  CRN: "cbo-crn",
  CRBM: "cbo-crbm",
  CREFONO: "cbo-crefono",
  CREF: "cbo-cref",
};

/** URL canônica do ValueSet de conselhos (r5). */
export function getConselhosSaudeUrl(): string {
  return `${FHIR_R5_VALUESET_BASE}/${CONSELHOS_SAUDE_VALUESET_ID}`;
}

/**
 * Retorna a URL canônica do CBO para o conselho, ou undefined se não houver
 * ValueSet específico (fallback: não buscar).
 */
export function getCboValueSetUrl(
  conselho?: string | null,
): string | undefined {
  if (!conselho) return undefined;
  const valueSetId = CBO_VALUESET_BY_CONSELHO[conselho];
  if (!valueSetId) return undefined;
  return `${FHIR_R5_VALUESET_BASE}/${valueSetId}`;
}

/** ID do ValueSet de CBO para o conselho, ou "" se não mapeado. */
export function getCboValueSetId(conselho?: string | null): string {
  if (!conselho) return "";
  return CBO_VALUESET_BY_CONSELHO[conselho] ?? "";
}
